import * as React from 'react';
import { templateReplace } from '../helpers';

export default function NvChartTooltip(props) {
  const {active, payload, chartConfig} = props;

  if (!active || !payload) return null;

  const {title, text} = chartConfig.tooltip;

  const textParts = text.split('\n');
  return (
    <div className="nv-chart-tooltip">
      {payload.map((p) => {
        const entry = p.payload[`${p.dataKey}__entry`];
        const entryText = textParts.map(part => `<div>${templateReplace(part, entry)}</div>`).join('');
        return (
          <div className='nv-chart-tooltip__group' key={p.dataKey}>
            <div className='nv-chart-tooltip__label'>{templateReplace(title, entry)}</div>
            <div className='nv-chart-tooltip__content'>
              <div className='nv-chart-tooltip__marker' style={{backgroundColor: p.stroke}}></div>
              <div className='nv-chart-tooltip__text' dangerouslySetInnerHTML={{__html: entryText}}></div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
